var mzg;
if (!mzg) {
    mzg = {};
}

$.extend(mzg,
    /**
     * @lends mzg
     */
    {
        /**
         * @namespace
         * @description Image Lazyload
         */
        lazyload: {
            /**
             * @type {function}
             * @description initialize Lazyload
             */
            init: function () {            
                var myLazyLoad = new LazyLoad({
                    elements_selector: ".lazy"
                });                
            }
        }
    }
);

$(mzg.lazyload.init);
